// Single source of truth for the brand's social profiles.
export const INSTAGRAM_URL = "https://www.instagram.com/astro.logicalsolutions";
export const FACEBOOK_URL = "https://www.facebook.com/share/1LpjJkShBa/";

// Customer-support WhatsApp number (country code + number, digits only).
export const WHATSAPP_NUMBER = "917351519573";
export const WHATSAPP_MESSAGE = "Hello Astro Logical Solutions, I would like some guidance.";
